var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEarphones = function SvgIconEarphones(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#320A4B",
    d: "M8.2 21H4.5q-.6 0-1.05-.45T3 19.5V12q0-1.874.712-3.512a9.2 9.2 0 0 1 1.926-2.85 9.2 9.2 0 0 1 2.85-1.925A8.7 8.7 0 0 1 12 3q1.874 0 3.512.712a9.2 9.2 0 0 1 2.85 1.926 9.2 9.2 0 0 1 1.926 2.85A8.7 8.7 0 0 1 21 12v7.5q0 .6-.45 1.05T19.5 21h-3.7v-7.4h3.7V12q0-3.125-2.187-5.312Q15.125 4.5 12 4.5T6.688 6.688 4.5 12v1.6h3.7zm-1.5-5.9H4.5v4.4h2.2zm10.6 0v4.4h2.2v-4.4z"
  })));
};
export default SvgIconEarphones;